// src/services/mercadosService.js
import apiClient from "./apiClient";
const USE_MOCK_ADMIN_MERCADOS = false;

const getMercadosDetalle = async (cod) => {
  try {
    const response = await apiClient.get(`SigiProdMici/GetIntervencionMercadosMinoristas?id_intervencion=${cod}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en mercados minoristas" };
  }
};

const mapMercadoData = (data) => {
  const items = Array.isArray(data) ? data : (data?.data || []);

  return items
    .filter((item) => (item.latitud || item.longitud))
    .map((item) => ({
      id: item.id || item.id_intervencion,
      nombre: item.nombre,
      departamento: item.ubigeo_dep,
      provincia: item.ubigeo_prov,
      distrito: item.ubigeo_dist,
      latitud: item.longitud, // Swapped intentionally as per legacy backend
      longitud: item.latitud, // Swapped intentionally as per legacy backend
      tipo: "MERCADOS DE ABASTOS MINORISTAS",
      id_ubigeo: item.id_ubigeo_dist,
      id_ubigeo_provincia: item.id_ubigeo_prov,
      id_ubigeo_distrito: item.id_ubigeo_dist,
      id_estado_intervencion: item.id_estado_intervencion,
      id_modalidad: item.id_modalidad,
      cui: item.cui,
      fechaActualizacion: item.fechaActualizacion,
    }));
};


// Función que obtiene los mercados minoristas
const getMercadosMinoristas = async () => {
  try {
    const response = await apiClient.get("SigiProdMici/GetMeracadosMinoristas");
    const mappedData = mapMercadoData(response.data);
    return mappedData;
  } catch (error) {
    console.error("[mercadosService] Error in getMercadosMinoristas:", error);
    throw error.response?.data || { message: "Error en mercados minoristas" };
  }
};



const getMercadosMayoristas = async (cod) => {
  try {
    const response = await apiClient.get(`SigiProdMici/GetDetalleIntervencion?id_intervencion=` + cod);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en mercados mayoristas" };
  }
};
/* ============================================================
 *  SERVICIOS BACKOFFICE ADMIN
 * ============================================================ */

// LISTADO
// mercadosService.js
const getMercadosAdminLista = async ({ page = 1, pageSize = 10 } = {}) => {
  try {
    const { data } = await apiClient.get("SigiProdMici/api/admin/mercados", {
      params: { page, pageSize },
    });

    return {
      recordsTotal: data?.recordsTotal ?? 0,
      recordsFiltered: data?.recordsFiltered ?? 0,
      items: Array.isArray(data?.items) ? data.items : [],
      page,
      pageSize,
    };
  } catch (error) {
    handleMercadosError("getMercadosAdminLista", "Error listando mercados admin.")(error);
    return { recordsTotal: 0, recordsFiltered: 0, items: [], page, pageSize };
  }
};



// DETALLE (Intervención)
const getMercadoAdminIntervencion = async (idIntervencion) => {
  try {
    const response = await apiClient.get(
      `SigiProdMici/api/admin/mercados/${idIntervencion}`
    );
    return response.data;
  } catch (error) {
    handleMercadosError(
      "getMercadoAdminIntervencion",
      "Error obteniendo detalle de la intervención."
    )(error);
  }
};

// CREAR (INSERT)
const createMercadoAdmin = async (payload) => {
  if (USE_MOCK_ADMIN_MERCADOS) {
    return Promise.resolve({ idIntervencion: 999 });
  }

  try {
    const response = await apiClient.post("SigiProdMici/api/admin/mercados", payload);
    return response.data; // que te devuelva el id nuevo
  } catch (error) {
    handleMercadosError(
      "createMercadoAdmin",
      "Error creando mercado."
    )(error);
  }
};

// ACTUALIZAR (UPDATE)
const updateMercadoAdmin = async (idIntervencion, payload) => {
  if (USE_MOCK_ADMIN_MERCADOS) {
    return Promise.resolve();
  }

  try {
    await apiClient.put(`SigiProdMici/api/admin/mercados/${idIntervencion}`, payload);
  } catch (error) {
    handleMercadosError(
      "updateMercadoAdmin",
      "Error actualizando mercado."
    )(error);
  }
};

export const getMercadoAdminDetalle = async (idIntervencion) => {
  const response = await apiClient.get(`SigiProdMici/api/admin/para-infra-int?id_intervencion=${idIntervencion}&id_tipo_infraestructura=1&page=1&pageSize=100`);
  return response.data;
};

export const updateMercadoAdminDetalle = async (idIntervencion, payloadArray) => {

  const arr = Array.isArray(payloadArray) ? payloadArray : [payloadArray];

  const response = await apiClient.put(
    `SigiProdMici/api/admin/para-infra-int/${idIntervencion}`,
    arr
  );

  return response.data;
};


export const getIntervencionParamDetalle = async (
  id_intervencion
) => {
  try {
    let url = `SigiProdMici/GetIntervencionParams?id_intervencion=${id_intervencion}`;

    // if (id_padre) url += `&id_padre=${id_padre}`;
    // if (id_capa) url += `&id_capa=${id_capa}`;

    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en detalle intervención" };
  }
};


// lista
export const getMercadoAdminImagenes = (idIntervencion) =>
  apiClient.get(`SigiProdMici/api/admin/mercados/${idIntervencion}/imagenes`).then(r => r.data);

// upload (FormData)
export const uploadMercadoAdminImagenes = (idIntervencion, formData) =>
  apiClient.post(`SigiProdMici/api/admin/mercados/${idIntervencion}/imagenes`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(r => r.data);

// delete
export const deleteMercadoAdminImagen = (idIntervencion, idImagen) =>
  apiClient.delete(`SigiProdMici/api/admin/mercados/${idIntervencion}/imagenes/${idImagen}`).then(r => r.data);




// saveParametrosInfra removed because it was unused


const mercadosService = {
  //poput
  getIntervencionParamDetalle,
  // Mapa
  getMercadosMinoristas,
  getMercadosMayoristas,
  getMercadosDetalle,

  // Backoffice
  getMercadosAdminLista,
  getMercadoAdminIntervencion,
  getMercadoAdminDetalle,
  createMercadoAdmin,
  updateMercadoAdmin,
  updateMercadoAdminDetalle,

  getMercadoAdminImagenes,
  uploadMercadoAdminImagenes,
  deleteMercadoAdminImagen,

  // PDFS (Ayuda Memoria)
  getMercadoAdminPdfs: (idIntervencion) =>
    apiClient.get(`SigiProdMici/api/admin/intervencion/${idIntervencion}/pdfs`).then(r => r.data),

  uploadMercadoAdminPdf: (idIntervencion, formData) =>
    apiClient.post(`SigiProdMici/api/admin/intervencion/${idIntervencion}/pdfs`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then(r => r.data),

  deleteMercadoAdminPdf: (idIntervencion, idPdf) =>
    apiClient.delete(`SigiProdMici/api/admin/intervencion/${idIntervencion}/pdfs/${idPdf}`).then(r => r.data),
};

export default mercadosService;

// mock data removed

/* ============================================================
 *  HELPER DE ERRORES
 * ============================================================ */
const handleMercadosError = (contexto, defaultMessage) => (error) => {
  console.error(`Error en mercadosService (${contexto}):`, error);
  // Si el backend devuelve { hasError, message, ... } lo respetamos
  throw error?.response?.data || {
    hasError: true,
    message: defaultMessage,
  };
};